var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.12375 0.593458C9.50366 -0.0974021 10.4963 -0.0974017 10.8763 0.593458L13.1634 4.75267C13.4684 5.30728 14.0179 5.6848 14.645 5.77053L18.7316 6.32921C19.5962 6.4474 19.9052 7.53875 19.231 8.09267L16.1822 10.5974C15.6105 11.0671 15.3448 11.814 15.4915 12.5393L16.3722 16.8933C16.5408 17.7267 15.6585 18.3769 14.9124 17.9691L10.9593 15.8081C10.3615 15.4813 9.63849 15.4813 9.04069 15.8081L5.08757 17.9691C4.34153 18.3769 3.45919 17.7267 3.62776 16.8933L4.50851 12.5393C4.65521 11.814 4.38952 11.0671 3.8178 10.5974L0.769044 8.09267C0.094805 7.53875 0.403832 6.4474 1.26839 6.32921L5.35498 5.77053C5.98208 5.6848 6.53159 5.30728 6.83658 4.75267L9.12375 0.593458Z",
    fill: "#FDDC03"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.cb7945a3.svg";
export { ForwardRef as ReactComponent };